export const KALEIDOSCOPE_SOURCE_IMAGES = [
  {
    id: "aurora-glass",
    label: "Aurora Glass",
    path: "/kaleidoscope/aurora-glass.svg",
  },
  {
    id: "citrus-prism",
    label: "Citrus Prism",
    path: "/kaleidoscope/citrus-prism.svg",
  },
  {
    id: "deep-orchid",
    label: "Deep Orchid",
    path: "/kaleidoscope/deep-orchid.svg",
  },
  {
    id: "mineral-flare",
    label: "Mineral Flare",
    path: "/kaleidoscope/mineral-flare.svg",
  },
  {
    id: "solar-ink",
    label: "Solar Ink",
    path: "/kaleidoscope/solar-ink.svg",
  },
] as const;

export const DEFAULT_KALEIDOSCOPE_SOURCE_IMAGE_INDEX = 0;

export function normalizeKaleidoscopeSourceImageIndex(value: unknown) {
  if (typeof value !== "number" || !Number.isFinite(value)) {
    return DEFAULT_KALEIDOSCOPE_SOURCE_IMAGE_INDEX;
  }

  return Math.min(KALEIDOSCOPE_SOURCE_IMAGES.length - 1, Math.max(0, Math.round(value)));
}
